export type TAlertLoading = {
  show?: boolean;
  label?: string;
};

export default function AlertLoading(props: TAlertLoading) {
  return <>
    {props.show && <div className="alert alert-info mb-3">
      {typeof props.label === "string" ? props.label : "Loading..."}
    </div>}
  </>;
}
